/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { NO_MARGIN_BOTTOM } from '@constants';
import { EXTENSIONS, ALL_FILE_TYPES, MEDIA_TYPE } from '@api/media/constants';
import * as mediaUtils from '@utils/media';
import { Typography } from '@atoms';

import FileSelect from '../FileSelect';

import s from './styles.module.less';

const MediaFileSelect = ({ file, media, onChange, dropAreaText, title, type: defaultType }) => {
  const { fileName, src, type, typeName } = mediaUtils.getInfo({ file, media });

  const accept = React.useMemo(() => {
    // Lock type if it's already created media document
    if (media && type) return EXTENSIONS[type]?.join(',');

    if (defaultType) return EXTENSIONS[defaultType]?.join(',');

    return ALL_FILE_TYPES;
  }, [defaultType, media, type]);

  const disabled = media && type === MEDIA_TYPE.UNKNOWN;
  const showPreview = type === MEDIA_TYPE.IMAGE && src;

  return (
    <>
      <FileSelect
        file={file}
        onChange={onChange}
        dropAreaText={dropAreaText}
        title={title || `Upload new ${typeName}`}
        accept={accept}
        disabled={disabled}
        showUploadArea={!src && !file}
      >
        {fileName && (
          <>
            <Typography.Paragraph style={!showPreview && NO_MARGIN_BOTTOM}>
              {media?.title || fileName}
            </Typography.Paragraph>
            {showPreview && (
              <div className={s.imagePreview}>
                <img src={src} alt="" />
              </div>
            )}
          </>
        )}
      </FileSelect>
    </>
  );
};
export default MediaFileSelect;
